import {graphql} from 'react-relay'

export const pipelineQuery = graphql`
  query PipelineRunPagePipelineQuery($locator: String!) {
    pipeline(pipelineLocator: $locator) {
      ...PipelineRunHeaderFragment
    }
  }
`
